import { Environment } from '@abp/ng.core';

const baseUrl = 'https://admin.artcast.tv';

export const environment = {
    production: true,
    application: {
        baseUrl,
        name: 'Artcast',
    },
    oAuthConfig: {
        issuer: 'https://identity.artcast.tv',
        redirectUri: baseUrl,
        clientId: 'Artcast_App',
        responseType: 'code',
        scope: 'offline_access Artcast',        
    },
    apis: {
        default: {
            url: 'https://api.artcast.tv',
        },
    },
} as Environment;
